import React, { FunctionComponent } from "react";
import ctx from "classnames";
import { Input } from "antd";

import { ViewProps } from "./common";

import styles from "./common.module.scss";
import { getTranslations } from "../../features/translations/translationsUtils";

const { TextArea } = Input;

export const SMS: FunctionComponent<ViewProps> = ({ message, setMessage, maxMessageCount }) => {
  return (
    <div className={ctx(styles.container, styles.sms)}>
      <div className={styles.title}>{getTranslations('NOTIFICATION_DETAILS')}</div>
      <div className={styles.label}>{getTranslations('NOTIFICATION_MESSAGE')}</div>
      <TextArea
        placeholder={getTranslations('NOTIFICATION_WRITE_MESSAGE')}
        value={message}
        onChange={event => {
          setMessage(event.target.value);
        }}
        className={styles.textarea}
        rows={4}
      />
      <div className={styles.counter}>{message.length} / {maxMessageCount}</div>
    </div>
  );
};
